import { render } from "./CompaniesServingAreaBody.vue?vue&type=template&id=fc30c12c"
import script from "./CompaniesServingAreaBody.vue?vue&type=script&lang=js"
export * from "./CompaniesServingAreaBody.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/felipe_admin_sr/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__